import lowerFirst from './lowerFirst';

/**
 * @param {string} prefix
 * @param {string} value
 */
export default function unPrefixPropName(prefix, value) {
  return lowerFirst(value.replace(prefix, ''));
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/utils/unPrefixPropName.js
// module id = 574
// module chunks = 0